// NumbersCell.tsx
import React, { useState } from 'react';

interface NumbersCellProps {
  value: any;
  config?: { format?: 'number' | 'currency' | 'percentage'; decimals?: number; currency?: string };
  onChange?: (value: string) => void;
  readOnly?: boolean;
}

export const NumbersCell: React.FC<NumbersCellProps> = ({ value, config, onChange, readOnly }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState('');

  const format = config?.format || 'number';
  const decimals = config?.decimals ?? 2;
  const currency = config?.currency || 'BRL';

  let numValue = 0;
  try {
    if (typeof value === 'string') {
      const parsed = JSON.parse(value);
      numValue = parsed.value || parseFloat(parsed) || 0;
    } else if (typeof value === 'number') {
      numValue = value;
    } else if (value?.value !== undefined) {
      numValue = value.value;
    }
  } catch (e) {
    numValue = parseFloat(value) || 0;
  }

  const formatNumber = (num: number) => {
    if (format === 'currency') {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }).format(num);
    } else if (format === 'percentage') {
      return `${num.toFixed(decimals)}%`;
    } else {
      return new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      }).format(num);
    }
  };

  const handleStartEdit = () => {
    if (!readOnly) {
      setIsEditing(true);
      setEditValue(numValue.toString());
    }
  };

  const handleSave = () => {
    const newValue = parseFloat(editValue) || 0;
    if (onChange) {
      onChange(JSON.stringify({ value: newValue }));
    }
    setIsEditing(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      handleSave();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
    }
  };

  if (isEditing) {
    return (
      <input
        type="number"
        value={editValue}
        onChange={(e) => setEditValue(e.target.value)}
        onBlur={handleSave}
        onKeyDown={handleKeyDown}
        className="w-full px-3 py-1.5 text-sm border border-blue-500 rounded focus:outline-none"
        autoFocus
      />
    );
  }

  return (
    <div
      onClick={handleStartEdit}
      className="w-full px-3 py-1.5 text-sm hover:bg-gray-50 rounded cursor-pointer"
    >
      {formatNumber(numValue)}
    </div>
  );
};

